import { Component, EventEmitter, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-close-button',
  templateUrl: './close-button.component.html',
  imports: [IconComponent],
})
export class CloseButtonComponent {
  @Output() close = new EventEmitter<void>();
}
